import { API_URL } from "constants/index";
import { toast } from "react-toastify";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { RentalContract } from "shared/types/rental-contracts";

export const syncProductsFromOdoo = async (contract: RentalContract, session: any, fetchRentalContracts: () => void) => {
    if (!contract.odooContractId) {
      return toast.error("Contract heeft geen Odoo ID - kan niet synchroniseren");
    }

    try {
      const response = await fetchWithAuth(
        `${API_URL}/rental/contracts/${contract.id}/sync-products-from-odoo`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
        session,
      );
      if (response.ok) {
        toast.success("Producten succesvol gesynchroniseerd vanuit Odoo!");
        fetchRentalContracts();
      } else {
        const errorData = await response.json();
        toast.error(`Fout bij synchroniseren van producten: ${errorData.message || "Onbekende fout"}`);
      }
    } catch (error) {
      console.error("Error syncing products from Odoo:", error);
      toast.error("Netwerk- of serverfout bij synchroniseren van producten.");
    }
  };